import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useRef } from "react";
import Modal from "./modal";
import Close from "../icons/close-white.svg";

const DeclarationModal = ({ show, onHide, type }) => {
  const ref = useRef(null);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
        nonExistentDocument
        serviceNotAvailable
      }
    }
  `);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const closeDialog = useCallback(() => {
    if (ref.current) {
      onHide();
    }
  }, [onHide]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeDialog();
      }
    },
    [closeDialog]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`youtube-modal${show ? " youtube-modal--show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
      >
        <div className="youtube-modal__dialog" role="document">
          <button
            className="youtube-modal__close"
            onClick={closeDialog}
            aria-label={labelManagerLabels.close}
          >
            <Close />
          </button>

          <div className="youtube-modal__alert">
            <div className="youtube-modal__alert-content text-center">
              <div className="youtube-modal__alert-title">
                {type === null
                  ? labelManagerLabels.nonExistentDocument
                  : labelManagerLabels.serviceNotAvailable}
              </div>
              <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-3 mt-md-4">
                <button
                  className="youtube-modal__alert-close btn-link btn-link--white"
                  onClick={closeDialog}
                >
                  {labelManagerLabels.close}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeclarationModal;
